module.exports = ["Lion","Spectre","Orc","Rat","Tigre","Lynx","Gargouille","Cerbere","Golem","Chimere","Satyre","Pan","Sirene","Araignée","Grizzli","Loup","Frelon","Ver","Scorpion","Moustique","Vautour","Warg","Komodo","Centaure","Griffon","Phenix","Sphinx","Phoenix","Basilic","Troll","Geant","Blob","Gobelin","Cyclope","Ogre","Vampire","Demon","Dragon","Squelette","Bete","Harpie","Lutin","Diablotin","Hydre","Wyvern","Bahamut","Minotaure","Serpent","Meduse"]


//////////////////
// WEBPACK FOOTER
// ./src/data/enemies.json
// module id = vI4t
// module chunks = 1